import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_PACKING_REPORT_TEMPLATE_PRE_DATA,
  GET_PACKING_REPORT_TEMPLATE_VARIABLE_DATA,
  RESET_PACKING_REPORT_TEMPLATE_VARIABLE_DATA,
} from "../ActionTypes";

const initialState = {
  buyers: [],
  variables: [],
  font_weights: [],
  font_sizes: [],
  text_alignments: [],
  variableData: [],
  error: null,
  message: null,
  loading: false,
};

const PackingReportTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: null, message: null, loading: true };
    }

    case GET_PACKING_REPORT_TEMPLATE_PRE_DATA:
      return {
        ...state,
        buyers: action.payload.buyers,
        variables: action.payload.variables,
        font_weights: action.payload.font_weights,
        font_sizes: action.payload.font_sizes,
        text_alignments: action.payload.text_alignments,
        error: null,
        message: null,
        loading: false,
      };

    case FETCH_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: null,
      };
    }

    case GET_PACKING_REPORT_TEMPLATE_VARIABLE_DATA: {
      return {
        ...state,
        variableData: action.payload,
        error: null,
        message: null,
        loading: false,
      };
    }


    case RESET_PACKING_REPORT_TEMPLATE_VARIABLE_DATA: {
      return {
        ...state,
        variableData: [],
        error: null,
        message: null,
        loading: false,
      };
    }

    // case CREATE_NEW_BANK:
    //     return {
    //         ...state,
    //         createdBank: action.payload.data,
    //         bankList: [action.payload.data, ...state.bankList],
    //         totalBank: state.totalBank + 1,
    //     };

    // case DELETE_BANK: {
    //     return {
    //         ...state,
    //         bankList: action.payload.list,
    //         totalBank: action.payload.total,
    //     };
    // }

    // case GET_BANK_DETAIL:
    //     return {
    //         ...state,
    //         selectedBank: action.payload,
    //         selectedBankAccountInfo: action.payload,
    //         selectedBankDetails: action.payload,
    //     };

    // case UPDATE_BANK_DETAIL:
    //     return {
    //         ...state,
    //         selectedBank: action.payload,
    //         bankList: state.bankList.map((bank) =>
    //             bank.id === action.payload.id ? action.payload : bank,
    //         ),
    //     };

    default:
      return state;
  }
};

export default PackingReportTemplateReducer;
